import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient,HttpHeaders,HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { User } from '../_models/user';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private userSubject!: BehaviorSubject<User>;
  public user!: Observable<User>;
  private headers=new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
  constructor( private router: Router,private http: HttpClient) { 

    this.userSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user') || '{}'));
    this.user = this.userSubject.asObservable();

  }

  public get userValue(): User {
    return this.userSubject.value;
  }

  login(name:any, password:any) {
      return this.http.post<User>(`${environment.APIEndpoint}/getadminlogin`, { name, password })
          .pipe(map(user => {
        
              //this.userSubject.next(user);
              return user;
            
              // store user details and jwt token in local storage to keep user logged in between page refreshes
              
          }));
  }

  logout() {
      // remove user from local storage and set current user to null
      localStorage.removeItem('user');
      //this.userSubject.next(null);
      this.router.navigate(['/account/login']);
  }

 

}
